import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';

/**
 * Get the base URL for the schedule FE service.
 */
export const getBaseScheduleFEUrl = () => `${getAccOrigin()}/build/schedule`;
